import { useEffect } from "react"

import { PlusIcon, CheckIcon } from "lucide-react"
import { Button, DefaultPopover, DefaultTooltip, CommandSearch, CommandGroupSearch, CommandItemSearch } from "twyne-new.ui"

const ConfigInputs = ({ transition = {}, displayedInputs, onChange }) => {
  const { delay, behavior } = transition

  useEffect(() => {
    if (displayedInputs === undefined) {
      const newDisplayedInputs = ['property', 'timing function', 'duration']

      if (behavior) newDisplayedInputs.push('behavior')
      if (delay) newDisplayedInputs.push('delay')

      onChange(newDisplayedInputs)
    }
  }, [displayedInputs, behavior, delay, onChange])

  const handleChangeDisplayedInputs = input => {
    onChange(prev => prev.includes(input) ? prev.filter(item => item !== input) : [...prev, input])
  }

  if (!displayedInputs) {
    return null
  }

  return <DefaultPopover trigger={<ButtonTriggerAdvanced />} contentProps={{ side: 'top' }} >
    <CommandSearch placeholder='Type to search transition property...'>
      <CommandGroupSearch heading=''>
        {INPUTS.map(input => <Item
          key={input}
          value={input}
          active={displayedInputs.includes(input)}
          onChange={handleChangeDisplayedInputs} />,
        )}
      </CommandGroupSearch>
    </CommandSearch>
  </DefaultPopover>
}

const ButtonTriggerAdvanced = () => <DefaultTooltip side='right' content='Advanced properties' triggerProps={{ asChild: true }}>
  <Button variant='light' size='sm'>
    <PlusIcon size='14' />
  </Button>
</DefaultTooltip>

const Item = ({ value, active, onChange }) => <>
  <div onClick={() => onChange(value)} className="group">
    <CommandItemSearch key={value?.name || value} className="twy-text-base hover:twy-bg-base-neutral cursor-pointer flex items-center justify-between">
      <div className="flex items-center">
        {value?.name || value}
        {active && <CheckIcon size='12' className='ml-1' />}
      </div>
    </CommandItemSearch>
  </div>
</>

const INPUTS = ['property', 'timing function', 'duration', 'delay', 'behavior']

export default ConfigInputs
